// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/3838
import type { PAPEventGeneric } from "../base/event";
import type { DashSurface } from "../enums/dash_surface";
import type { DashActionSurface } from "../enums/dash_action_surface";
import type { ActionSurfaceComponent } from "../enums/action_surface_component";
import type { FeatureLine } from "../enums/feature_line";
import type { OmniboxFocusMode } from "../enums/omnibox_focus_mode";

// Event_name: 'click.omnibox_chip'
// Description: User clicks/selects new scoped action modes on the Dash Omnibar (Find, Ask, Write, etc.)
// Owner: dash-exp-find-and-discover
export type Click_OmniboxChip = PAPEventGeneric<
  'dash',
  'click',
  'omnibox_chip',
  {
    // Which Dash surface (web, desktop, or browser extension) the event originated from.
    dashSurface?: DashSurface;
    // The surface in which an action was taken on Dash.
    // Note: serp and search_result_page are the same thing, but we're only using serp moving forward.
    dashActionSurface?: DashActionSurface;
    // The component within a surface in which an action was taken on Dash.
    actionSurfaceComponent?: ActionSurfaceComponent;
    // Feature Line for dash
    featureLine?: FeatureLine;
    // id that groups all queries in a single "session" for logging
    searchSessionId?: string;
    // Omnibox Mode (Find/Write/Ask/Organize/Default)
    omniboxFocusMode?: OmniboxFocusMode;
  }
>;

export function PAP_Click_OmniboxChip(properties?: Click_OmniboxChip['properties']): Click_OmniboxChip {
  return <Click_OmniboxChip>{
    class: 'dash',
    action: 'click',
    object: 'omnibox_chip',
    properties,
  };
}
